import $ from "jquery";
import React, {PureComponent} from 'react';
import Map from 'ol/Map';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import {fromLonLat} from "ol/proj";
import Overlay from "ol/Overlay";
import View from "ol/View";
import Feature from "ol/Feature";
import LineString from "ol/geom/LineString";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import flagIcon from '../../img/marshall.png';
import map from "async/map";
import parallel from "async/parallel";

import {
    subscribeToMapInfo,
    subscribeDashToServer,
    connectSocket,
    closeSocket,
    subscribeSessionStatus
} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import Toggle from "react-bootstrap-toggle";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

// Create a pattern, offscreen
const patternCanvas = document.createElement('canvas');
const patternContext = patternCanvas.getContext('2d');
// Give the pattern a width and height of 50
patternCanvas.width = 50;
patternCanvas.height = 50;

class PopoutTrack extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            markersArray: [],
            marshallPosts: [],
            markersActive: false,
            markerType: "S",
            selectedCar: -1,
        };

        this.putSectorMarkers = this.putSectorMarkers.bind(this);
        this.clearMarkers = this.clearMarkers.bind(this);
        this.getFlagList = this.getFlagList.bind(this);
        this.statusIDtoObj = this.statusIDtoObj.bind(this);
        this.statusParser = this.statusParser.bind(this);
        this.getMarshallPostList = this.getMarshallPostList.bind(this);
        this.onToggleMarkers = this.onToggleMarkers.bind(this);
        this.getSectors = this.getSectors.bind(this);
        this.onToggleMarkerType = this.onToggleMarkerType.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);
    }

    /* LIFE-CYCLE */
    componentDidMount() {
        const helper = this;
        $(".loading").fadeIn();
        parallel([
            function (p_callback) {
                helper.getFlagList((status) => {
                    p_callback(null, status);
                });
            },
            function (p_callback) {
                helper.getMarshallPostList((status) => {
                    p_callback(null, status);
                });
            },
            function (p_callback) {
                helper.getSectors((status) => {
                    p_callback(null, status);
                });
            },
            function (p_callback) {
                helper.getSessionDetails((status) => {
                    p_callback(null, status);
                });
            },
            function (p_callback) {
                connectSocket(helper.props.cookies.get("authToken"), null, helper.props.match.params.sessionID, helper.props.match.params.eventID, "MAP.JS", (msg, answer) => {
                    console.log("[MAP POPOUT]" + msg);
                    subscribeDashToServer(helper.props.match.params.eventID, helper.props.match.params.sessionID, () => {
                        console.log("[MAP.JS] DEDICATED STREAM SUBSCRIBED");
                        p_callback(null, "ok");
                    });
                });
            }
        ], function (err, results) {
            helper.map = new Map({
                target: "map",
                layers: [
                    new TileLayer({
                        source: new XYZ({
                            attributions: 'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer">ArcGIS</a>',
                            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                        })
                    }),
                ],
                view: new View({
                    center: fromLonLat([helper.state.center_lng, helper.state.center_lat]),
                    zoomFactor: 1.1,
                    zoom: helper.state.zoom + (helper.props.match.params.windowWidth > 1200 ? 9 : 0),
                    maxZoom: 141,
                    rotation: helper.state.map_rotation,
                }),
                loadTilesWhileAnimating: true,
                loadTilesWhileInteracting: true,
            });

            $(".loading").fadeOut();

            subscribeToMapInfo(helper.props.match.params.eventID, false, (error, coords) => {
                map(coords, function (coord, callback) {
                    // Check if there's already a marker for this car
                    let marker = null;
                    let iconColor = "#000000";
                    let flagColor = "#FFFFFF";
                    let flagTextColor = "#000000";

                    if (coord.lng !== 0 && coord.lat !== 0) {

                        if (helper.map.getOverlayById(coord.cid) || [2, 3].includes(parseInt(coord.rsi))) {
                            marker = helper.map.getOverlayById(coord.cid);
                            try {
                                if ([2, 3].includes(parseInt(coord.rsi))) {
                                    if (marker !== null) helper.map.removeOverlay(marker);
                                } else {

                                    marker.setPosition(fromLonLat([coord.lng, coord.lat]));

                                    if (helper.props.match.params.carID > 0 && helper.state.selectedCar < 0) {
                                        helper.setState({
                                            selectedCar: helper.props.match.params.carID,
                                        });
                                    }

                                    if (parseInt(coord.cid) === parseInt(helper.state.selectedCar)) {
                                        iconColor = "#b10c0e";
                                        flagColor = "#b10c0e";
                                        flagTextColor = "#FFFFFF";
                                    }

                                    document.getElementById(coord.cid).style.color = iconColor;
                                    document.getElementById("flag_" + coord.cid).style.background = flagColor;
                                    document.getElementById("flag_" + coord.cid).style.color = flagTextColor;
                                }
                            } catch (e) {
                                console.log(e);
                            }

                        } else {

                            const innerDiv = $('' +
                                '<div id="car_id_marker_' + coord.cid + '">' +
                                '   <p id="flag_' + coord.cid + '" class="carPinText" style="font-size: 16px !important;">#' + coord.cln + '</p>' +
                                '   <span class="fa-stack carPin">' +
                                '       <i id="' + coord.cid + '" class="fa fa-circle fa-stack-2x" style="line-height: inherit;color: ' + iconColor + '"/><i class="fa fa-car fa-stack-1x fa-inverse" style="font-size:15px;margin:inherit"/>' +
                                '   </span>' +
                                '</div>').get(0);

                            const overlay = new Overlay({
                                id: coord.cid,
                                element: innerDiv,
                                position: fromLonLat([coord.lng, coord.lat]),
                                offset: [0, 10],
                                positioning: 'bottom-center',
                                className: 'animation_move'
                            });

                            helper.map.addOverlay(overlay);

                            $('#car_id_marker_' + coord.cid).click((e) => {
                                try {
                                    const carID = parseInt(e.currentTarget.id.split('_')[3]);
                                    console.log("[TRACK POPOUT] CLICKED ON #" + carID);
                                    helper.setState({
                                        selectedCar: carID,
                                    });
                                } catch (e) {
                                    console.error(e);
                                }
                            });
                        }
                    }
                    callback(null, "done");
                });
            });

            subscribeSessionStatus(helper.props.match.params.eventID, false, (err, pack) => {
                let sessionStatus = helper.statusIDtoObj(helper.statusParser(pack.sts));
                // check if there are active layers
                helper.map.getLayers().forEach((layer) => {
                    if (layer && layer.get('name') && layer.get('name') === "sectors") {
                        helper.map.removeLayer(layer);
                    }
                });
                let featureArr = [];
                for (let i = 0; i < sessionStatus.length; i++) {
                    if (sessionStatus[i] !== null) {
                        let coords = [];
                        for (let c = 0; c < helper.state.marshallPosts[i].polyline.length; c++) {
                            coords.push(fromLonLat([
                                helper.state.marshallPosts[i].polyline[c].lng,
                                helper.state.marshallPosts[i].polyline[c].lat
                            ]));
                        }

                        let style = null;
                        if (sessionStatus[i].second_color) {
                            let color1 = sessionStatus[i].first_color;
                            let color2 = sessionStatus[i].second_color;
                            let numberOfStripes = 50;
                            for (let x = 0; x < numberOfStripes * 2; x++) {
                                let thickness = 300 / numberOfStripes;
                                patternContext.beginPath();
                                patternContext.strokeStyle = x % 2 ? color1 : color2;
                                patternContext.lineWidth = thickness;
                                patternContext.lineCap = 'round';

                                patternContext.moveTo(x * thickness + thickness / 2 - 300, 0);
                                patternContext.lineTo(x * thickness + thickness / 2, 300);
                                patternContext.stroke();
                            }

                            // Create our primary canvas and fill it with the pattern
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');
                            const pattern = ctx.createPattern(patternCanvas, 'repeat');
                            ctx.fillStyle = pattern;
                            ctx.fillRect(0, 0, canvas.width, canvas.height);

                            style = new Style({
                                stroke: new Stroke({
                                    lineCap: "round",
                                    lineJoin: "round",
                                    width: 15,
                                    color: pattern,
                                }),
                            });
                        } else {
                            style = new Style({
                                stroke: new Stroke({
                                    lineCap: "round",
                                    lineJoin: "round",
                                    width: 15,
                                    color: sessionStatus[i].first_color,
                                }),
                            });
                        }
                        let feature = new Feature({
                            geometry: new LineString(coords),
                            name: 'Line',
                        });
                        feature.setStyle(style);
                        featureArr.push(feature);
                    }
                }
                let layerLines = new VectorLayer({
                    name: "sectors",
                    className: "dash_map_sectors",
                    source: new VectorSource({
                        features: featureArr
                    }),
                });
                helper.map.addLayer(layerLines);
            });
        });
    }

    componentWillUnmount() {
        subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
            console.log("[DASHBOARD] DEDICATED STREAM UNSUBSCRIBED");
        });
        subscribeToMapInfo(this.props.match.params.eventID, true, null);
        subscribeSessionStatus(this.props.match.params.eventID, true, null);
        closeSocket();
    }

    /* GET DATA */
    getSessionDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    center_lat: data.map_center_lat,
                    center_lng: data.map_center_lng,
                    zoom: data.map_center_zoom_level,
                    map_rotation: data.map_rotation,
                }, () => {
                    console.log(data);
                    console.log("[MAP.JS] COMPLETE getSessionDetails");
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getFlagList(callback) {
        const helper = this;
        $.ajax({
            type: 'GET',
            url: serverIP + ":" + backendPort + '/dashboard/getFlagList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            success: function (data) {
                helper.setState({
                    flagList: data.collective.concat(data.singular).concat(data.fullCourse),
                }, () => {
                    console.log("[MAP.JS] getFlagList COMPLETED");
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.setState({
                    flagList: [
                        {id: -1, desc: "---", src: "none_transparent.png"}
                    ],
                });
                callback("nok");
            }
        });
    }

    getMarshallPostList(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getMarshallPostList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                if (data && data.length > 0) {
                    helper.setState({
                        marshallPosts: data
                    }, () => {
                        console.log("[MAP.JS] getMarshallPostList COMPLETED");
                        callback("ok");
                    });
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getSectors(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSectorInfo',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    sectorMarkers: data,
                }, () => {
                    console.log("[MAP.JS] getSectors COMPLETED");
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    /* HANDLER */
    statusIDtoObj(arr) {
        let temp = [];
        for (let i = 0; i < arr.length; i++) {
            temp.push(null);
            for (let j = 0; j < this.state.flagList.length; j++) {
                if (this.state.flagList[j].id === arr[i]) {
                    temp[i] = this.state.flagList[j];
                    break;
                }
            }
        }
        return temp;
    }

    statusParser(sts) {
        let newStatus = [];
        let found = false;

        for (let p = 0; p < this.state.marshallPosts.length; p++) {

            found = false;

            for (let s = 0; s < Object.keys(sts).length; s++) {
                if (this.state.marshallPosts[p].order_no === parseInt(Object.keys(sts)[s])) {
                    newStatus.push(sts[Object.keys(sts)[s]]);
                    found = true;
                    break;
                }
            }

            if (!found) {
                newStatus.push(0);
            }
        }

        return newStatus;
    }

    onToggleMarkers() {
        this.setState({
            markersActive: !this.state.markersActive,
        }, () => {
            if (this.state.markersActive) {
                this.putSectorMarkers();
            } else {
                this.clearMarkers();
            }
        });
    }

    onToggleMarkerType() {
        this.setState({
            markerType: (this.state.markerType === "S" ? "P" : "S"),
        }, () => {
            this.clearMarkers();
            this.putSectorMarkers();
        });
    }

    /* RENDER */
    putSectorMarkers() {

        let currentSector = 0;
        for (let i = 0; i < this.state.sectorMarkers.length; i++) {

            if (this.state.markerType === "S") {
                if (![0, 3, 6].includes(this.state.sectorMarkers[i].order_no)) {
                    continue;
                }
            }

            let flagText = '';
            if ([0, 3, 6].includes(this.state.sectorMarkers[i].order_no) && this.state.markerType === "S") {
                currentSector++;
                flagText = 'S' + currentSector;
            } else {
                flagText = 'P' + (this.state.sectorMarkers[i].order_no + 1);
            }

            const innerDiv = $('' +
                '<div class="sectorFlag">' +
                '<span class="sectorText">' + flagText + ' </span>' +
                '<img style="height: 100%; width:100%" src="' + flagIcon + '" alt="sector"/>' +
                '</div>' +
                '').get(0);

            this.map.addOverlay(
                new Overlay({
                    id: "flag_" + (i + 1),
                    element: innerDiv,
                    position: fromLonLat([this.state.sectorMarkers[i].internal_point_lng, this.state.sectorMarkers[i].internal_point_lat]),
                    offset: [-2, 4],
                    positioning: 'bottom-left',
                })
            );
        }
    }

    clearMarkers() {
        for (let i = 0; i < this.state.sectorMarkers.length; i++) {
            let overlay = this.map.getOverlayById("flag_" + (i + 1));
            if (overlay) {
                this.map.removeOverlay(overlay);
            }
        }
    }

    render() {
        return (
            <>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                <div style={{position: "relative"}}>
                    <div style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        padding: 10,
                        marginTop: 50,
                        zIndex: 10,
                        height: 100,
                        width: 100
                    }}>
                        <Toggle
                            onClick={this.onToggleMarkers}
                            on={
                                <div style={{width: "100%"}}>
                                    <span><i className="fab fa-font-awesome-flag"/></span>
                                </div>
                            }
                            off={
                                <div style={{width: "100%"}}>
                                    <span><i className="fab fa-font-awesome-flag"/></span>
                                </div>
                            }
                            height={"50%"}
                            width={"100%"}
                            onstyle={"success"}
                            offstyle={"danger"}
                            handlestyle={"primary"}
                            style={{
                                textAlign: "center",
                                borderRadius: 5,
                            }}
                            active={this.state.markersActive}
                        />
                        {this.state.markersActive ? (
                            <Toggle
                                onClick={this.onToggleMarkerType}
                                on={
                                    <div style={{width: "100%"}}>
                                        <span className={"App_title"}><b style={{color: "#FFFFFF"}}>S</b></span>
                                    </div>
                                }
                                off={
                                    <div style={{width: "100%"}}>
                                        <span className={"App_title"}><b style={{color: "#FFFFFF"}}>P</b></span>
                                    </div>
                                }
                                height={"50%"}
                                width={"100%"}
                                onstyle={"danger"}
                                offstyle={"primary"}
                                handlestyle={"success"}
                                style={{
                                    marginTop: 15,
                                    textAlign: "center",
                                    borderRadius: 5,
                                }}
                                active={this.state.markerType === "S"}
                            />
                        ) : null}
                    </div>
                    <div style={{height: "100%", width: "100%", position: "fixed"}} id={"map"}/>
                </div>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(PopoutTrack));
